import { useEffect } from "react";
import { useIsMounted, EventService } from "@perxis-auto/shared";
import "../../../config/env.js";
import { APP_EVENTS } from "../../../config/events.js";
import "../../../lib/store/createAppApi.js";
import "../../../lib/store/createAppAsyncThunk.js";
import "../../../lib/store/createAppSelector.js";
import "../../../lib/store/createAppSlice.js";
import "redux";
import { useAppDispatch } from "../../../lib/store/hooks/useAppDispatch.js";
import "../../../lib/store/hooks/useAppSelector.js";
import "../../../lib/store/hooks/useAppStore.js";
import { actions } from "../model/slice.js";
const usePageReady = ({ onReady, isReady = true }) => {
  const isMounted = useIsMounted();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (isReady && isMounted.current.mounted) {
      dispatch(actions.setPageReady(true));
      EventService.getInstance().sendEvent(APP_EVENTS.ConstructorReadyToRender);
      onReady == null ? void 0 : onReady();
    }
  }, [isReady]);
};
export {
  usePageReady
};
